import React from 'react';
import { BRAND, isBrandOV, isMarketGB } from '../../../constants/main';
import { OptionsSelectStyledAC } from './AC/OptionsSelectStyled.AC';
import { OptionsSelectStyledAP } from './AP/OptionsSelectStyled.AP';
import { OptionsSelectStyledDS } from './DS/OptionsSelectStyled.DS';
import { OptionsSelectStyledOV } from './OV/OptionsSelectStyled.OV';
import { OptionsSelectStyledOVGB } from './OV/GB/OptionsSelectStyled.OV.GB';
import { OptionsSelectStyled } from './OptionsSelectStyled';
import { SC } from '../../../styles/theme';

export type OptionsSelectProps = SC & {};

const OptionsSelect = (props: OptionsSelectProps) => {
    if (isBrandOV) return isMarketGB ? <OptionsSelectStyledOVGB {...props} /> : <OptionsSelectStyledOV {...props} />;
    if (BRAND === 'AC') return <OptionsSelectStyledAC {...props} />;
    if (BRAND === 'AP') return <OptionsSelectStyledAP {...props} />;
    if (BRAND === 'DS') return <OptionsSelectStyledDS {...props} />;
    return <OptionsSelectStyled {...props} />;
};

export default OptionsSelect;
